// extracted by mini-css-extract-plugin
export default {"table":"key-account-list_table__DbshJ","iconCustom":"key-account-list_iconCustom__sjJVT"};